"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _types = require("../../../utils/types");
var _Mail = _interopRequireDefault(require("./Mail"));
require("./MailsView.scss");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MailsView = function MailsView(_ref) {
  var _ref$mails = _ref.mails,
    mails = _ref$mails === void 0 ? [] : _ref$mails,
    draftMessages = _ref.draftMessages,
    _ref$openMails = _ref.openMails,
    openMails = _ref$openMails === void 0 ? [] : _ref$openMails,
    _toggle = _ref.toggle,
    contact = _ref.contact,
    campaign = _ref.campaign,
    onReply = _ref.onReply,
    onAttachments = _ref.onAttachments,
    onUploadAttachments = _ref.onUploadAttachments,
    onDeleteAttachment = _ref.onDeleteAttachment,
    IsAzure = _ref.IsAzure,
    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
    onDeleteDraftMessage = _ref.onDeleteDraftMessage,
    onDialog = _ref.onDialog;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-view"
  }, mails.length === 1 ? /*#__PURE__*/_react["default"].createElement(_Mail["default"], {
    mail: mails[0],
    contact: mails[0].origin === _constants.MSG_SOURCE.USER ? contact : campaign,
    sender: mails[0].origin === _constants.MSG_SOURCE.USER ? campaign : contact,
    onReply: onReply,
    draft: draftMessages[mails[0].id],
    onUpdateDraftMessage: onUpdateDraftMessage,
    onUpdateDraftAttachments: onUpdateDraftAttachments,
    onAttachments: onAttachments,
    onUploadAttachments: onUploadAttachments,
    onDeleteAttachment: onDeleteAttachment,
    IsAzure: IsAzure,
    onDeleteDraftMessage: onDeleteDraftMessage,
    onDialog: onDialog
  }) : mails.map(function (mail, i) {
    return /*#__PURE__*/_react["default"].createElement(_Mail["default"], {
      key: i,
      mail: mail,
      contact: mail.origin === _constants.MSG_SOURCE.USER ? contact : campaign,
      sender: mail.origin === _constants.MSG_SOURCE.USER ? campaign : contact,
      isOpen: openMails.includes(mail.id),
      toggle: function toggle() {
        return _toggle(mail.id);
      },
      onReply: onReply,
      draft: draftMessages[mail.id],
      onUpdateDraftMessage: onUpdateDraftMessage,
      onUpdateDraftAttachments: onUpdateDraftAttachments,
      onAttachments: onAttachments,
      onUploadAttachments: onUploadAttachments,
      onDeleteAttachment: onDeleteAttachment,
      onDeleteDraftMessage: onDeleteDraftMessage,
      IsAzure: IsAzure,
      onDialog: onDialog
    });
  }));
};
MailsView.propTypes = {
  mails: _propTypes["default"].arrayOf(_types.messageType),
  openMails: _propTypes["default"].arrayOf(_propTypes["default"].number),
  toggle: _propTypes["default"].func,
  userImage: _propTypes["default"].element,
  contact: _types.contactType,
  campaign: _types.contactType,
  onReply: _propTypes["default"].func,
  onAttachments: _propTypes["default"].func,
  onUploadAttachments: _propTypes["default"].func
};
var _default = exports["default"] = MailsView;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/MailView/MailsView.js
// module id = 1407
// module chunks = 0